import { render } from "./WalletExchangeSummaryCard.vue?vue&type=template&id=7978cabf&scoped=true"
import script from "./WalletExchangeSummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletExchangeSummaryCard.vue?vue&type=script&lang=js"

import "./WalletExchangeSummaryCard.vue?vue&type=style&index=0&id=7978cabf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7978cabf"]])

export default __exports__